import useStyles from "./Svg.styles";


const DragVertical: React.FC = () => {
    const classes = useStyles();

    return (
        <svg className={classes.dragVertical} viewBox="0 0 24 24">
            <path fill="currentColor" d="M11 21H9V3H11V21M15 3H13V21H15V3Z" />
        </svg>
    );
};

type LvtLogoBlackProps = {
    width?: number;
    height?: number;
};

const LvtLogoBlack: React.FC<LvtLogoBlackProps> = ({ width = 52, height = 24 }: LvtLogoBlackProps) => {
    const classes = useStyles();

    return (
        <svg className={classes.lvtLogoBlack} width={width} height={height} viewBox="0 0 52 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_7_340)">
                <path d="M16.2479 0H9.47357L20.0254 24H20.0589H26.7997L16.2479 0Z" fill="black" />
                <path d="M14.2699 18.3486H6.20542V0H0V24H16.7535L14.2699 18.3486Z" fill="black" />
                <path d="M51.9597 0H30.607L25.0634 12.6116L28.4542 20.3228L34.905 5.64771H38.1472V24H44.3526V5.64771H49.4761L51.9597 0Z" fill="black" />
            </g>
            <defs>
                <clipPath id="clip0_7_340">
                    <rect width="51.9597" height="24" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

const LvtLogoFullBlack: React.FC = () => {
    return (
        <svg
            // className={classes.lvtLogoFullBlack}
            xmlns="http://www.w3.org/2000/svg"
            width="1320.08"
            height="258"
            viewBox="0 0 1320.08 258"
            fill="currentColor"
        >
            <g className="liveViewText" data-name="5fcd18451d0e59f2fac10086_logo-full 1" transform="translate(0 -0.5)">
                <path
                    id="Path_172"
                    data-name="Path 172"
                    d="M73.332,115.317v.588c0,1.372.392,1.568,1.76,1.568h54.071c6.071,0,9.011,2.156,9.011,6.855s-3.528,7.644-8.815,7.644H70c-9.4,0-11.363-2.936-11.363-17.243v-.98l.2-102.463v-.592C58.829,4.03,60.984.7,65.688.7c4.5,0,7.443,3.136,7.443,7.835v1.568Z"
                    transform="translate(452.095 1.562)"
                />
                <path
                    id="Path_173"
                    data-name="Path 173"
                    d="M85.543,122.93V124.3a7.2,7.2,0,0,1-7.443,7.443c-4.7,0-7.051-2.744-7.051-8.428V9.888C71.048,4.2,73.788.681,78.5.681c5.091,0,7.443,2.94,7.443,9.207v.588Z"
                    transform="translate(547.828 1.393)"
                />
                <path
                    id="Path_174"
                    data-name="Path 174"
                    d="M128.88,125.61c-1.559,4.7-3.528,6.463-6.459,6.463-2.744,0-4.708-1.568-5.88-5.287l-.2-.784L77.356,12.564l-.2-.98a7.08,7.08,0,0,1-.984-3.724A7.157,7.157,0,0,1,83.615.613q5.3,0,7.056,5.875c.2.784.4.784.4.784L121.232,95.24l.192.392c.4.98.592.98.984.98.392-.392.78-.392,1.176-1.372L153.557,7.86c0-.392,0-.2.2-.98,1.172-3.92,3.719-6.267,7.056-6.267,4.107,0,7.639,3.332,7.639,6.855a20.223,20.223,0,0,1-.784,4.312l-.392.98Z"
                    transform="translate(587.366 0.867)"
                />
                <path
                    id="Path_175"
                    data-name="Path 175"
                    d="M165.276.888h.784c5.292,0,8.423,2.744,8.423,7.247,0,4.7-2.94,7.056-8.232,7.056H108.225c-2.151,0-2.931.588-2.931,2.156V57.316c0,1.764.588,2.156,2.544,2.156h.784l42.739.2h.98c5.292,0,8.623,2.548,8.623,6.664a7.3,7.3,0,0,1-7.639,7.639h-.784l-44.9-.2h-.784c-1.176,0-1.96.588-1.96,1.372v1.176l-.192,39.38v.98c0,.784.775,1.372,1.96,1.372h58.022c6.071,0,9.4,2.548,9.4,7.247a7.32,7.32,0,0,1-7.443,7.443H99.419c-7.051,0-9.207-1.96-9.207-9.011v-.2L90.8,11.859v-.976C90.8,2.265,92.956.5,103.539.5h1.176Z"
                    transform="translate(695.589 0.003)"
                />
                <path
                    id="Path_176"
                    data-name="Path 176"
                    d="M154.435,125.61c-1.568,4.7-3.528,6.463-6.455,6.463-2.744,0-4.7-1.568-5.888-5.287l-.2-.784L102.912,12.564l-.2-.98a7.081,7.081,0,0,1-.984-3.724A7.159,7.159,0,0,1,109.175.613q5.292,0,7.056,5.875c.192.784.383.784.383.784L146.787,95.24l.2.392c.383.98.592.98.984.98.383-.392.775-.392,1.167-1.372L179.112,7.86c0-.392,0-.2.2-.98,1.176-3.92,3.728-6.267,7.047-6.267,4.12,0,7.648,3.332,7.648,6.855a20.228,20.228,0,0,1-.784,4.312l-.392.98Z"
                    transform="translate(784.38 0.867)"
                />
                <path
                    id="Path_177"
                    data-name="Path 177"
                    d="M130.249,122.93V124.3a7.2,7.2,0,0,1-7.439,7.443c-4.7,0-7.047-2.744-7.047-8.428V9.888c0-5.684,2.744-9.207,7.448-9.207,5.087,0,7.439,2.94,7.439,9.207v.588Z"
                    transform="translate(892.607 1.393)"
                />
                <path
                    id="Path_178"
                    data-name="Path 178"
                    d="M197.234.888h.784c5.287,0,8.423,2.744,8.423,7.247,0,4.7-2.944,7.056-8.232,7.056H140.188c-2.151,0-2.935.588-2.935,2.156V57.316c0,1.764.584,2.156,2.543,2.156h.784l42.743.2h.984c5.287,0,8.615,2.548,8.615,6.664a7.3,7.3,0,0,1-7.639,7.639H184.5l-44.895-.2h-.784c-1.185,0-1.96.588-1.96,1.372v1.176l-.2,39.38v.98c0,.784.784,1.372,1.96,1.372h58.03c6.08,0,9.4,2.548,9.4,7.247a7.313,7.313,0,0,1-7.448,7.443H131.372c-7.047,0-9.2-1.96-9.2-9.011v-.2l.575-111.674v-.976C122.749,2.265,124.909.5,135.493.5h1.167Z"
                    transform="translate(942.039 0.003)"
                />
                <path
                    id="Path_179"
                    data-name="Path 179"
                    d="M248.8,125.226c-1.376,4.9-3.528,6.855-7.056,6.855-3.728,0-5.679-2.152-7.448-8.031l-25.461-90.9v-.588c-.4-.784-.592-.784-.784-.784a1.379,1.379,0,0,0-.592.98l-.2.2-26.053,90.12c-1.96,6.86-4.12,9.207-8.031,9.207-3.136,0-5.688-2.352-6.855-7.056l-.2-.784L135.747,13.155a26,26,0,0,1-.976-5.292C134.771,4.14,138.3,1,142.21,1c3.728,0,6.28,2.156,7.448,6.468l.192.98,22.735,82.873.192.392c.392,1.176.392,1.176.784,1.176.584-.2.775-.2,1.167-1.568v-.392l23.127-79.741C199.8,4.336,203.141,1,208.036,1s8.231,3.724,10.183,11.167c.2.784.392.784.392.98l22.334,78.365v.392c.2.784.392.784.784.784a1.368,1.368,0,0,0,.592-.784l.392-1.176.192-.588,22.134-79.933c1.768-6.664,4.321-9.6,8.423-9.6,4.312,0,7.448,2.935,7.448,7.051,0,1.568-.392,2.744-1.167,5.488v.392l-30.574,110.3Z"
                    transform="translate(1039.17 0.86)"
                />
                <path
                    id="Path_180"
                    data-name="Path 180"
                    d="M101.949,22.075h.732c3.132,0,4.8,1.354,4.8,3.863,0,2.6-1.463,3.754-4.9,3.754h-14.6c-.627,0-.941.518-.941,1.354v55.9c0,3.236-1.459,4.9-3.963,4.9s-3.859-1.568-3.859-4.9V30.843c0-1.05-.1-1.145-1.25-1.145h-14.6c-3.754,0-5.213-.949-5.213-3.654,0-2.814,1.355-3.963,4.691-3.963h39.106Z"
                    transform="translate(448.392 166.358)"
                />
                <path
                    id="Path_181"
                    data-name="Path 181"
                    d="M111.434,22.169h.418c2.818,0,4.486,1.459,4.486,3.859,0,2.5-1.568,3.754-4.386,3.754H75.973c-1.145,0-1.564.314-1.564,1.145V52.2c0,.941.314,1.145,1.354,1.145h.414l27.848.1h.523c2.814,0,4.595,1.355,4.595,3.55a3.889,3.889,0,0,1-4.068,4.068h-.418l-28.993-.109h-.418c-.623,0-1.041.314-1.041.727v.627l-.1,20.962V83.8c0,.418.414.732,1.041.732H111.12c3.236,0,5.009,1.355,5.009,3.854a3.9,3.9,0,0,1-3.968,3.968H71.282c-3.754,0-4.9-1.041-4.9-4.8v-.1l.314-59.45v-.523c0-4.586,1.145-5.531,6.777-5.531H74.1Z"
                    transform="translate(511.817 165.431)"
                />
                <path
                    id="Path_182"
                    data-name="Path 182"
                    d="M82.615,67.543c0,10.636,7.2,18.253,17,18.253a16.834,16.834,0,0,0,14.29-7.408l.627-.941c1.354-1.768,2.191-2.291,3.654-2.291a3.721,3.721,0,0,1,3.854,3.545c0,1.254-.523,2.609-1.982,4.482A25.2,25.2,0,0,1,99.614,93.614c-14.494,0-24.925-11.054-24.925-26.489v-.209l.1-19.4V47.1A24.805,24.805,0,0,1,100.036,21.86c8.136,0,15.749,3.863,19.917,10.122a33.107,33.107,0,0,1,3.236,6.359,7.4,7.4,0,0,1,.836,3.023,3.973,3.973,0,0,1-4.177,3.754c-1.873,0-2.5-.623-3.645-3.545-2.918-7.613-8.972-12.095-16.476-12.095-9.595,0-17.1,7.922-17.1,17.935v20.13Z"
                    transform="translate(575.895 164.695)"
                />
                <path
                    id="Path_183"
                    data-name="Path 183"
                    d="M133.11,86.912v.1c0,3.336-1.254,4.8-3.754,4.8-2.609,0-4.068-1.559-4.068-4.273V62.1c0-1.045-.1-1.045-1.673-1.045H91.808c-.841,0-1.15.314-1.15,1.259h.1v.523l-.209,24.394v.732a3.836,3.836,0,0,1-3.963,3.968c-2.5,0-3.754-1.463-3.754-4.486V27.048c0-3.023,1.459-4.9,3.963-4.9,2.713,0,3.968,1.564,3.968,4.9V51.974c0,.941.2,1.145,1.254,1.145h32.016c1.041,0,1.25-.2,1.25-1.35v-24.2c0-3.65,1.359-5.531,3.863-5.531,2.4,0,3.963,2.086,3.963,5.109V86.912Z"
                    transform="translate(638.721 166.081)"
                />
                <path
                    id="Path_184"
                    data-name="Path 184"
                    d="M141.447,87.4c0,3.014-1.037,4.586-3.232,4.586a4.885,4.885,0,0,1-3.963-2.613l-.213-.3-33.266-48.4c0-.109,0-.109-.1-.2-.1-.314-.209-.314-.418-.314-.209.2-.418.2-.418.727V41.2l-.1,46.3v.318c0,2.814-1.463,4.386-3.963,4.386-2.609,0-3.863-1.463-3.863-4.8v-.314l.109-58.614v-.936c0-3.868.932-5.213,3.75-5.213,1.568,0,2.609.618,3.859,2.6.209.418.418.418.418.523l32.643,47.665.113.1a.56.56,0,0,0,.518.314c.213-.2.314-.2.314-.623V26.9c0-3.327,1.359-4.9,4.068-4.9,2.5,0,3.854,1.668,3.854,4.591v.1l-.1,59.968V87.4Z"
                    transform="translate(708.611 165.804)"
                />
                <path
                    id="Path_185"
                    data-name="Path 185"
                    d="M108.217,65.392v.523c0,11.995,6.986,19.817,17.63,19.817,10.74,0,17.726-7.927,17.726-20.026V49.748c0-9.595-2.5-14.708-8.867-18.149a17.439,17.439,0,0,0-8.554-2.191c-10.113,0-17.935,8.245-17.935,18.985v17Zm43.074.1v.418c0,15.954-10.74,27.425-25.557,27.425-8.859,0-17.935-5.2-21.9-12.613a30.03,30.03,0,0,1-3.336-14.4V47.766a25.612,25.612,0,0,1,25.653-25.858c9.294,0,18.467,5.418,22.116,13.031a34.815,34.815,0,0,1,3.023,15.021V65.5Z"
                    transform="translate(774.911 165.072)"
                />
                <path
                    id="Path_186"
                    data-name="Path 186"
                    d="M117.046,83.077v.314c0,.727.209.841.941.841h28.78c3.232,0,4.8,1.141,4.8,3.645s-1.882,4.064-4.7,4.064h-31.6c-5.009,0-6.054-1.564-6.054-9.181v-.518l.113-54.55v-.309c0-3.55,1.141-5.318,3.641-5.318a3.838,3.838,0,0,1,3.972,4.168v.841Z"
                    transform="translate(842.117 166.263)"
                />
                <path
                    id="Path_187"
                    data-name="Path 187"
                    d="M123.919,65.392v.523c0,11.995,6.986,19.817,17.63,19.817,10.74,0,17.726-7.927,17.726-20.026V49.748c0-9.595-2.5-14.708-8.867-18.149a17.415,17.415,0,0,0-8.554-2.191c-10.113,0-17.935,8.245-17.935,18.985v17Zm43.074.1v.418c0,15.954-10.74,27.425-25.548,27.425-8.867,0-17.944-5.2-21.907-12.613a30.03,30.03,0,0,1-3.327-14.4V47.766a25.612,25.612,0,0,1,25.653-25.858c9.285,0,18.458,5.418,22.108,13.031a34.814,34.814,0,0,1,3.023,15.021V65.5Z"
                    transform="translate(896.053 165.072)"
                />
                <path
                    id="Path_188"
                    data-name="Path 188"
                    d="M173.442,68.251v.314c0,14.081-10.636,24.821-24.407,24.821-13.972,0-24.4-10.853-24.4-25.553v-.314l-.1-19.5v-.2c0-5.74.732-9.49,2.4-13.245,3.441-7.408,12.517-12.722,21.594-12.722,9.39,0,18.249,5.518,22.012,13.554a4.385,4.385,0,0,1,.409,1.768,4.116,4.116,0,0,1-4.059,3.968c-1.359,0-2.09-.523-3.136-2.191l-.314-.618-.828-1.154c-2.613-4.477-8.449-7.713-14.19-7.713-6.359,0-12.831,4.064-15.017,9.381a16.48,16.48,0,0,0-1.037,6.468V68.155c0,10.218,6.986,17.517,16.576,17.517,9.7,0,16.794-7.3,16.794-17.413V62.523c0-.727-.418-.936-1.455-.936h-8.144c-2.6,0-4.373-1.677-4.373-3.963,0-2.509,1.768-3.863,4.791-3.863h12.1c3.963,0,4.8.945,4.8,5v9.486Z"
                    transform="translate(960.221 164.613)"
                />
                <path
                    id="Path_189"
                    data-name="Path 189"
                    d="M140.69,87.129v.732a3.836,3.836,0,0,1-3.963,3.968c-2.491,0-3.754-1.463-3.754-4.486V26.956c0-3.027,1.463-4.9,3.972-4.9,2.7,0,3.963,1.564,3.963,4.9v.309Z"
                    transform="translate(1025.307 166.175)"
                />
                <path
                    id="Path_190"
                    data-name="Path 190"
                    d="M182.224,22.169h.427c2.8,0,4.477,1.459,4.477,3.859,0,2.5-1.559,3.754-4.381,3.754H146.763c-1.15,0-1.568.314-1.568,1.145V52.2c0,.941.314,1.145,1.359,1.145h.409l27.848.1h.523c2.822,0,4.591,1.355,4.591,3.55a3.889,3.889,0,0,1-4.068,4.068h-.409l-29-.109h-.418c-.627,0-1.037.314-1.037.727v.627l-.113,20.962V83.8c0,.418.418.732,1.045.732h35.984c3.232,0,5.009,1.355,5.009,3.854a3.9,3.9,0,0,1-3.972,3.968H142.068c-3.754,0-4.9-1.041-4.9-4.8v-.1l.322-59.45v-.523c0-4.586,1.141-5.531,6.768-5.531h.627Z"
                    transform="translate(1057.622 165.431)"
                />
                <path
                    id="Path_191"
                    data-name="Path 191"
                    d="M171.9,54.869c.828.3,1.664.518,2.709.828,10.74,3.24,14.608,5.745,17.1,10.954a15.594,15.594,0,0,1,1.568,6.99c0,11.581-10.017,20.021-23.675,20.021-7.822,0-15.017-2.287-22.63-7.4a4.406,4.406,0,0,1-2.291-3.654,3.873,3.873,0,0,1,3.859-3.963c1.141,0,1.559.209,3.85,1.773,5.636,3.859,10.854,5.627,16.7,5.627,9.381,0,16.585-5.318,16.585-12.408a8.476,8.476,0,0,0-4.381-7.2,77.327,77.327,0,0,0-12.517-4.477C161.9,59.869,157,57.683,153.456,55.174a17.562,17.562,0,0,1-6.89-13.976c0-11.054,9.808-19.4,22.735-19.4a36.78,36.78,0,0,1,18.981,5.945,3.85,3.85,0,0,1,1.777,3.24,4.264,4.264,0,0,1-1.881,3.332,3.081,3.081,0,0,1-1.559.523c-1.045,0-1.986-.309-4.068-1.564a25.033,25.033,0,0,0-12.831-3.754c-8.658,0-15.331,5.218-15.331,11.89,0,5.531,4.068,9.072,14.294,12.413Z"
                    transform="translate(1115.606 164.23)"
                />
            </g>
            <g className="liveViewLV" data-name="5fcd18451d0e59f2fac10086_logo-full 1" transform="translate(0 -0.5)">
                <path
                    id="Path_192"
                    data-name="Path 192"
                    d="M5.658.51A5.657,5.657,0,0,0,0,6.168v246.6a5.657,5.657,0,0,0,5.658,5.658H181.943l-26.533-60.7H66.689V6.168A5.657,5.657,0,0,0,61.031.51Z"
                    transform="translate(0 0.077)"
                />
                <path
                    id="Path_193"
                    data-name="Path 193"
                    d="M16.926.5a5.144,5.144,0,0,0-4.569,7.282L122.473,258.5H199.21L88.611,5.5a8.331,8.331,0,0,0-7.456-5Z"
                    transform="translate(91.647)"
                />
                <path
                    id="Path_194"
                    data-name="Path 194"
                    d="M84.674.5a5.363,5.363,0,0,0-5.022,3.48L30.285,135.062l39.742,90.922L131.372,62.642h76.553a8.332,8.332,0,0,0,7.757-5.287L236.331,4.572A2.986,2.986,0,0,0,233.548.5Z"
                    transform="translate(233.517)"
                />
            </g>
        </svg>
    );
};

const SignOut: React.FC = () => {
    return (
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M14 5L12.59 6.41L14.17 8H6V10H14.17L12.59 11.58L14 13L18 9L14 5ZM2 2H9V0H2C0.9 0 0 0.9 0 2V16C0 17.1 0.9 18 2 18H9V16H2V2Z"
                fill="currentColor"
            />
        </svg>
    );
};

const ManageAccountOutline: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            enableBackground="new 0 0 24 24"
            height="24px"
            viewBox="0 0 24 24"
            width="24px"
            fill="currentColor"
        >
            <g>
                <path d="M0,0h24v24H0V0z" fill="none" />
            </g>
            <g>
                <g>
                    <path d="M4,18v-0.65c0-0.34,0.16-0.66,0.41-0.81C6.1,15.53,8.03,15,10,15c0.03,0,0.05,0,0.08,0.01c0.1-0.7,0.3-1.37,0.59-1.98 C10.45,13.01,10.23,13,10,13c-2.42,0-4.68,0.67-6.61,1.82C2.51,15.34,2,16.32,2,17.35V20h9.26c-0.42-0.6-0.75-1.28-0.97-2H4z" />
                    <path d="M10,12c2.21,0,4-1.79,4-4s-1.79-4-4-4C7.79,4,6,5.79,6,8S7.79,12,10,12z M10,6c1.1,0,2,0.9,2,2s-0.9,2-2,2 c-1.1,0-2-0.9-2-2S8.9,6,10,6z" />
                    <path d="M20.75,16c0-0.22-0.03-0.42-0.06-0.63l1.14-1.01l-1-1.73l-1.45,0.49c-0.32-0.27-0.68-0.48-1.08-0.63L18,11h-2l-0.3,1.49 c-0.4,0.15-0.76,0.36-1.08,0.63l-1.45-0.49l-1,1.73l1.14,1.01c-0.03,0.21-0.06,0.41-0.06,0.63s0.03,0.42,0.06,0.63l-1.14,1.01 l1,1.73l1.45-0.49c0.32,0.27,0.68,0.48,1.08,0.63L16,21h2l0.3-1.49c0.4-0.15,0.76-0.36,1.08-0.63l1.45,0.49l1-1.73l-1.14-1.01 C20.72,16.42,20.75,16.22,20.75,16z M17,18c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S18.1,18,17,18z" />
                </g>
            </g>
        </svg>
    );
};

const LiveUnitIcon: React.FC = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 18" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path fill="currentColor" fillRule="evenodd" clipRule="evenodd" d="M20.75 12.02C21.44 12.02 22 12.58 22 13.27H21.96V15.19H21.09C21.24 15.55 21.34 15.87 21.34 16.11C21.34 17.15 20.49 18 19.45 18C18.41 18 17.56 17.16 17.56 16.11C17.56 15.87 17.66 15.55 17.81 15.19H16.94V13.27C16.94 12.58 17.5 12.02 18.19 12.02H18.46V9.21C18.46 8.7 18.04 8.28 17.53 8.28H16.31V10.28H14.31V2H7.65V10.28H5.65V8.28H4.43C3.92 8.28 3.5 8.7 3.5 9.21V12.02H3.77C4.46 12.02 5.02 12.58 5.02 13.27V15.19H4.15C4.3 15.55 4.4 15.87 4.4 16.11C4.4 17.15 3.55 18 2.51 18C1.47 18 0.62 17.16 0.62 16.11C0.62 15.87 0.72 15.55 0.87 15.19H0V13.27C0 12.58 0.56 12.02 1.25 12.02H1.52V9.21C1.52 7.59 2.84 6.28 4.45 6.28H5.67V0H16.33V6.28H17.55C19.17 6.28 20.48 7.6 20.48 9.21V12.02H20.75ZM11.94 12.02H12.24C12.93 12.02 13.49 12.58 13.49 13.27V15.19H12.62C12.77 15.55 12.87 15.87 12.87 16.11C12.87 17.15 12.02 18 10.98 18C9.93997 18 9.08997 17.16 9.08997 16.11C9.08997 15.87 9.18997 15.55 9.33997 15.19H8.46997V13.27C8.46997 12.58 9.02997 12.02 9.71997 12.02H9.93997V7.39001C9.93997 6.84001 10.39 6.39001 10.94 6.39001C11.49 6.39001 11.94 6.84001 11.94 7.39001V12.02Z" />
        </svg>
    );
};

const Shield: React.FC = () => {
    const classes = useStyles();

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            width="24px"
            height="24px"
            xmlSpace="preserve"
            className={classes.shieldIcon}
            fill="currentColor"
        >
            <path
                style={{
                    fill: "none",
                }}
                d="M0 0h24v24H0z"
            />
            <path d="M12 2 4 5v6.1c0 5 3.4 9.8 8 10.9 4.6-1.1 8-5.9 8-10.9V5l-8-3zm6 9.1c0 4-2.6 7.7-6 8.8-3.4-1.1-6-4.8-6-8.8V6.4l6-2.2 6 2.2v4.7z" />
            <path d="M10.2 12.3h1.4v1.6c0 1.5-.4 1.9-1.7 1.9h-.7c-1.3 0-1.7-.4-1.7-1.9V9.3c0-1.5.3-1.9 1.7-1.9h.7c1.3 0 1.7.4 1.7 1.9v1.5h-1.4V9.5c0-.5-.1-.7-.5-.7h-.2c-.4 0-.5.2-.5.7v4.2c0 .5.1.7.5.7h.2c.4 0 .5-.2.5-.7v-1.4zM15 12.3h1.4v1.6c0 1.5-.4 1.9-1.7 1.9H14c-1.3 0-1.7-.4-1.7-1.9V9.3c0-1.5.3-1.9 1.7-1.9h.7c1.3 0 1.7.4 1.7 1.9v1.5H15V9.5c0-.5 0-.7-.4-.7h-.2c-.4 0-.5.2-.5.7v4.2c0 .5.1.7.5.7h.2c.4 0 .5-.2.5-.7v-1.4z" />
        </svg>
    );
};

const LUAdmin: React.FC = () => {
    const classes = useStyles();

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            xmlSpace="preserve"
            width="24px"
            height="24px"
            className={classes.luadminIcon}
            fill="currentColor"
        >
            <path
                style={{
                    fill: "none",
                }}
                d="M0 0h24v24H0z"
            />
            <path d="M18 10.5V6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-4.5l4 4v-11l-4 4zM16 18H4V6h12v12zM10 6.8 5.7 8.7v2.8c0 2.6 1.8 5.1 4.3 5.7 2.4-.6 4.3-3.1 4.3-5.7V8.7L10 6.8z" />
        </svg>
    );
};

const Sounds: React.FC = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 11V13H22V11H18ZM16 17.61C16.96 18.32 18.21 19.26 19.2 20C19.6 19.47 20 18.93 20.4 18.4C19.41 17.66 18.16 16.72 17.2 16C16.8 16.54 16.4 17.08 16 17.61ZM20.4 5.6C20 5.07 19.6 4.53 19.2 4C18.21 4.74 16.96 5.68 16 6.4C16.4 6.93 16.8 7.47 17.2 8C18.16 7.28 19.41 6.35 20.4 5.6ZM4 9C2.9 9 2 9.9 2 11V13C2 14.1 2.9 15 4 15H5V19H7V15H8L13 18V6L8 9H4ZM15.5 12C15.5 10.67 14.92 9.47 14 8.65V15.34C14.92 14.53 15.5 13.33 15.5 12Z" fill="#616161" />
        </svg>
    );
};

const AlertTimelineConnector: React.FC = () => {

    return (
        <svg width="60" height="20">
            <g transform="translate(5,10)">
                <circle fill="#616161" r="4px" />
                <line x1="0" y1="0" x2="50" y2="0" stroke="#616161" strokeWidth="1.5" strokeDasharray="8 5" />
                <circle fill="#616161" r="4px" cx="50px" />
            </g>
        </svg>
    );
};

const ImageNotFound: React.FC = () => {
    const styles = useStyles();

    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={styles.imageNotFound}>
            <g clipPath="url(#clip0_621_12906)">
                <path d="M21.19 21.1901L20.41 20.4101L18 18.0001L13.41 13.4101L3.58999 3.59008L2.80999 2.81008C2.41999 2.42008 1.78999 2.42008 1.39999 2.81008C0.999986 3.20008 0.999986 3.83008 1.38999 4.22008L2.99999 5.83008V19.0001C2.99999 20.1001 3.89999 21.0001 4.99999 21.0001H18.17L19.78 22.6101C20.17 23.0001 20.8 23.0001 21.19 22.6101C21.58 22.2201 21.58 21.5801 21.19 21.1901ZM6.01999 18.0001C5.59999 18.0001 5.36999 17.5201 5.62999 17.1901L8.11999 13.9901C8.31999 13.7401 8.69999 13.7301 8.89999 13.9801L11 16.5101L12.17 15.0001L15.17 18.0001H6.01999ZM21 18.1701L5.82999 3.00008H19C20.1 3.00008 21 3.90008 21 5.00008V18.1701Z" fill="#BDBDBD" />
            </g>
            <defs>
                <clipPath id="clip0_621_12906">
                    <rect width="24" height="24" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

const Presets: React.FC = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path fill="currentColor" d="M24 11H22C21.7652 8.6989 20.74 6.55035 19.099 4.92026C17.458 3.29017 15.3026 2.27936 13 2.06V0H11V2.06C8.69738 2.27936 6.54203 3.29017 4.901 4.92026C3.25997 6.55035 2.23476 8.6989 2 11H0V13H2C2.23258 15.3029 3.25684 17.4538 4.89807 19.0859C6.5393 20.718 8.69585 21.7303 11 21.95V24H13V21.95C15.3042 21.7303 17.4607 20.718 19.1019 19.0859C20.7432 17.4538 21.7674 15.3029 22 13H24V11ZM19.9299 11H16.9299C16.7322 10.0409 16.2573 9.16104 15.564 8.46951C14.8707 7.77798 13.9896 7.30528 13.03 7.11002V4.11002C14.7787 4.33743 16.4032 5.13622 17.651 6.38223C18.8988 7.62825 19.7 9.25165 19.9299 11ZM11 4.07001V7.07001C10.0404 7.26527 9.15925 7.738 8.46594 8.42953C7.77263 9.12107 7.2977 10.0009 7.09998 10.96H4.09998C4.32992 9.21164 5.13108 7.58827 6.37891 6.34225C7.62673 5.09624 9.25132 4.29742 11 4.07001ZM4.06995 13H7.06995C7.26591 13.9609 7.74015 14.8429 8.43359 15.5364C9.12703 16.2298 10.0091 16.704 10.97 16.9V19.9C9.21981 19.6721 7.59419 18.8718 6.34619 17.6238C5.09819 16.3758 4.29785 14.7502 4.06995 13ZM13 19.93V16.93C13.9609 16.734 14.8429 16.2598 15.5364 15.5664C16.2298 14.8729 16.7041 13.9909 16.9 13.03H19.9C19.6721 14.7802 18.8718 16.4058 17.6238 17.6538C16.3758 18.9018 14.7502 19.7021 13 19.93Z" />
        </svg>
    );
};

const ClickAndDrag: React.FC = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path d="M22 12L18.79 8.79V11H13V5.21H15.21L12 2L8.79 5.21H11V11H5.21V8.79L2 12L5.21 15.21V13H11V18.79H8.79L12 22L15.21 18.79H13V13H18.79V15.21L22 12Z" fill="currentColor"/>
        </svg>
    );
};


const GuardGateIcon = () => {
    return (
        <svg
            data-fs-element="GUARD-GATE-ICON"
            width="24px"
            height="22px"
            viewBox="0 0 24 22"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_21_9667)">
                <path
                    id="Intersect"
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0.00366211 13.1392V13.1511H2.09125H9.85801L11.2186 8.69764L11.8296 6.69764V12.0756V14.2267H1.07558V16.2441H0.00366211V18.2441H4.31408C4.30587 18.338 4.30168 18.433 4.30168 18.5291C4.30168 20.3111 5.74612 21.7558 7.52793 21.7558C9.30975 21.7558 10.7542 20.3111 10.7542 18.5291C10.7542 18.4012 10.7468 18.2751 10.7323 18.1512H15.0558V16.3779H15.0559V12.2822V12.0756H13.9804L13.9804 3.47089H14.8005C14.7916 3.51433 14.787 3.55929 14.787 3.60534C14.787 3.97661 15.088 4.27758 15.4593 4.27758C15.8305 4.27758 16.1315 3.97661 16.1315 3.60534C16.1315 3.55929 16.1269 3.51433 16.118 3.47089H16.1313V2.39531H14.5303L13.9804 1.2705V0.244141H13.4787H12.3316H11.8296V1.27117L11.2801 2.39531L9.67877 2.39531V3.47089H9.69222C9.6834 3.51433 9.67877 3.55929 9.67877 3.60534C9.67877 3.97661 9.97974 4.27758 10.351 4.27758C10.7223 4.27758 11.0232 3.97661 11.0232 3.60534C11.0232 3.55929 11.0186 3.51433 11.0098 3.47089L11.8296 3.47089V6.69764H9.73836H1.9716L0.611018 11.1511L0.00366211 13.1392ZM15.5937 14.7865V11.7443L17.2067 10.131V13.1732L15.5937 14.7865ZM17.7445 12.6353L19.3575 11.022V7.97982L17.7445 9.59311V12.6353ZM21.5084 8.87086L19.8953 10.4842V7.44195L21.5084 5.82866V8.87086ZM22.0462 8.33299L23.9963 6.38253L22.4755 4.86142L22.0462 5.29078V8.33299ZM2.70227 11.1511L3.45184 8.69764H9.12734L8.37777 11.1511H2.70227ZM7.52793 19.7558C8.20489 19.7558 8.75419 19.2069 8.75419 18.5291C8.75419 17.8513 8.20489 17.3023 7.52793 17.3023C6.85098 17.3023 6.30168 17.8513 6.30168 18.5291C6.30168 19.2069 6.85098 19.7558 7.52793 19.7558Z"
                    fill="currentColor"
                />
            </g>
            <defs>
                <clipPath id="clip0_21_9667">
                    <rect width="24px" height="22px" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};


const ForensicSearchIcon = () => {
    return (
        <svg
            viewBox="0 0 18 20"
            width="24px"
            height="24px"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
            data-fs-element="FORENSIC-SEARCH-ICON"
        >
            <path d="M14.2457 9.24571L13 12L11.7543 9.24571L9 8L11.7543 6.75429L13 4L14.2457 6.75429L17 8L14.2457 9.24571Z" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.7767 6.30722C8.73866 5.40522 7.36274 4.85596 5.85334 4.85596C2.6205 4.85596 0 7.37562 0 10.4841C0 13.5925 2.6205 16.1122 5.85334 16.1122C7.30317 16.1122 8.63593 15.6013 9.66252 14.7528L9.90566 14.9952V15.6792L14.4082 19.9999L15.75 18.7098L11.2564 14.3804H10.545L10.2929 14.1467C10.8338 13.5416 11.2428 12.826 11.4783 12.0417L10.6602 10.3024L9.86931 9.95846C9.89328 10.1303 9.90566 10.3058 9.90566 10.4841C9.90566 12.6401 8.09563 14.3804 5.85334 14.3804C3.61106 14.3804 1.80103 12.6401 1.80103 10.4841C1.80103 8.32806 3.61106 6.58768 5.85334 6.58768C6.6026 6.58768 7.30359 6.782 7.90491 7.12122L9.7767 6.30722Z"
            />
            <path d="M7.62286 10.6229L7 12L6.37714 10.6229L5 10L6.37714 9.37714L7 8L7.62286 9.37714L9 10L7.62286 10.6229Z" />
            <path d="M10.2786 3.27857L9.5 5L8.72143 3.27857L7 2.5L8.72143 1.72143L9.5 0L10.2786 1.72143L12 2.5L10.2786 3.27857Z" />
        </svg>
    );
};

const VideoLibraryIcon = () => {
    return (
        <svg
            width="24px"
            height="24px"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            data-fs-element="VIDEO-LIBRARY-ICON"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0 6V11H0.01L0 20C0 21.1 0.9 22 2 22H20V20H2V6H0ZM24 16V6C24 4.9 23.1 4 22 4H14L12 2H6C4.9 2 4.01 2.9 4.01 4L4 16C4 17.1 4.9 18 6 18H22C23.1 18 24 17.1 24 16ZM17.5 10.5L21 15H7L11.5 9L15 13.51L17.5 10.5ZM6 16H22V6H13.17L12.58 5.41L11.17 4H6V16Z"
                fill="currentColor"
            />
        </svg>
    );
};

export {
    AlertTimelineConnector,
    ClickAndDrag,
    DragVertical,
    ForensicSearchIcon,
    GuardGateIcon,
    ImageNotFound,
    LUAdmin,
    LiveUnitIcon,
    LvtLogoBlack,
    LvtLogoFullBlack,
    ManageAccountOutline,
    Presets,
    Shield,
    SignOut,
    Sounds,
    VideoLibraryIcon,
};
